<app-tenants-table [tenants]="tenants | async" (manageTenantOffers)="manageTenantOffers($event)"></app-tenants-table>